module.exports = "/_next/static/images/99b40f5d107f9c4de669aa4a0fea99d6-phone-md.png";